
import React from 'react';
import { Link } from 'react-router-dom';
import SimpleInfoModal from '../ConfirmationModals/SimpleInfoModal';
import { OutlineCircleXIcon } from '../ConfirmationModals/CongratsIcon';

export interface AgeRestrictionModalProps {
  show: boolean;
  onClose: () => void;
}

const AgeRestrictionModal: React.FC<AgeRestrictionModalProps> = ({ show, onClose }) => (
  <SimpleInfoModal
    show={show}
    onHide={onClose}
    title="Age Restriction"
    body={
      <p>
        Thank you for your interest. Based on your information, you are over the age of 44 and do not qualify for this special offer.{' Click '}
        <Link to="/apply/term-life-add">here</Link> to enroll in the standard Term Life Insurance Plan for AFT members. If you have additional questions, please contact our customer service team at <a href="tel:8884238700">888.423.8700</a> Monday - Friday 8AM-8PM ET.
      </p>
    }
    buttonText="Close"
    fontAwesomeIcon={<OutlineCircleXIcon style={{ color: 'var(--bs-danger)' }} />}
  />
);

export default AgeRestrictionModal;
